export default "__VITE_ASSET__CTegUFgp__"